import { render } from "./tcle_start.vue?vue&type=template&id=2d869aea&scoped=true"
import script from "./tcle_start.vue?vue&type=script&lang=js"
export * from "./tcle_start.vue?vue&type=script&lang=js"

import "./tcle_start.vue?vue&type=style&index=0&id=2d869aea&lang=scss&scoped=true"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d869aea"]])

export default __exports__